import { PERMISSION_CATEGORIES, PERMISSIONS_BY_CATEGORY } from 'src/models/access-control/constants'
import Model from 'src/models/model'

const VALUE_TITLES = Object.freeze([
  'We Are Customer Obsessed',
  'We Never Settle',
  'We Own The Outcome',
  'We Always Do the Right Thing',
  'We Are a World Class Team',
  'Our Purpose',
  'Our Niche',
  'Our Target',
  'Three Uniques'
])
const VALUE_DESCRIPTIONS = Object.freeze([
  'We don\'t just meet expectations; we strive to exceed them. Our mission is to profoundly impact our customers\' lives for the better, evaluating every decision through the lens of customer benefit. We listen, we care, and we deliver.',
  'Innovation and excellence are our benchmarks. We embrace change as an opportunity for growth and are relentless in our pursuit of improvement. Satisfaction is not in our vocabulary; excellence is our constant goal.',
  'Accountability is our commitment. We are proactive leaders, fully invested in our responsibilities. With drive and determination, we see every goal through to completion, embracing both challenges and triumphs along the way.',
  'Integrity is our foundation. We are steadfast in our commitment to ethical behavior, transparency, and fairness in all our actions. Doing the right thing is not just a policy, it\'s our identity.',
  'Unity is our strength. We thrive in a culture of collaboration, positivity, and mutual respect. Our humility as leaders and our spirit as team players guide us. We share successes, shoulder challenges, and always put the team above the individual.',
  'Empowering cinemas to unlock their potential.',
  'Exceptional technology and constant innovation.',
  'A ticket sold for everyone person on the planet.',
  'We\'re not a Point of Sale, we\'re an Operating System. Dedicated to customer service excellence. A champion committed to your bottom line.'
])
const DAY_OF_WEEK_NUMBERS = Object.freeze([
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 0 }
])

export const LOCAL_STORAGE_KEYS = Object.freeze({
  darkMode: 'darkMode',
  isDemoMode: 'isDemoMode',
  lastSelectedLocation: 'lastSelectedLocation',
  loginHelpBannerDismissed: 'loginHelpBannerDismissed',
  previewedPermissions: 'previewedPermissions',
  seatChartConfirmations: 'seatChartConfirmations',
  useCurrentLocation: 'useCurrentLocation'
})

const ALCOHOL_ACKNOWLEDGEMENT_COOKIES = 'alcoholAcknowledgementCookie'
const SEAT_CHART_COOKIES = 'seatChartCookies'
const KDS_COOKIES = 'kitchenDisplayCookies'

const PREFERRED_LOCATIONS_COOKIES = 'preferredLocations'

const COOKIES_TYPE = Object.freeze({
  consumerConsent: 'consumer consent',
  useCurrentLocation: 'useCurrentLocation'
})

const FEATURE_FLAGS = Object.freeze({
  automatic_package_assignment: 'automatic_package_assignment',
  disable_google_recaptcha: 'disable_google_recaptcha',
  enable_activities: 'enable_activities',
  essential_reports_tab: 'essential_reports_tab',
  extra_kiosk_logs: 'extra_kiosk_logs',
  extra_recaptcha_info_logs: 'extra_recaptcha_info_logs',
  site_report_migration: 'site_report_migration',
  window_reload_on_register_logout: 'window_reload_on_register_logout'
})

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const constants = {}
  constants.cookies = {}
  constants.branches = {}
  constants.valueIndexes = Array.from(Array(VALUE_TITLES.length).keys())
  constants.valueTitles = VALUE_TITLES
  constants.valueDescriptions = VALUE_DESCRIPTIONS
  constants.dayOfWeekNumbers = DAY_OF_WEEK_NUMBERS
  constants.localStorageKeys = LOCAL_STORAGE_KEYS
  constants.cookies.alcoholAcknowledgement = ALCOHOL_ACKNOWLEDGEMENT_COOKIES
  constants.cookies.seatChartCookies = SEAT_CHART_COOKIES
  constants.cookies.kdsCookies = KDS_COOKIES
  constants.cookies.preferredLocations = PREFERRED_LOCATIONS_COOKIES
  constants.cookies.type = COOKIES_TYPE

  app.config.globalProperties.$constants = constants
  Model.prototype.$constants = constants

  app.config.globalProperties.$permissions = PERMISSIONS_BY_CATEGORY
  app.config.globalProperties.$permissionCategories = PERMISSION_CATEGORIES

  app.config.globalProperties.$featureFlags = FEATURE_FLAGS
  Model.prototype.$featureFlags = FEATURE_FLAGS
}
